import script from "./survey.vue?vue&type=script&setup=true&lang=js"
export * from "./survey.vue?vue&type=script&setup=true&lang=js"

import "./survey.vue?vue&type=style&index=0&id=f6264f8c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6264f8c"]])

export default __exports__